import axios from "axios";
import { handlerError } from "utils";
import { notification } from 'antd';


export const getByIdCard = async (user) => {
    try {
        const { data } = await axios.get(`/card/${user}`);
        const card = data.card ? (Array.isArray(data.card) ? [...data.card] : [data.card]) : []
        return card;
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const createOrder = async (user) => {
    try {
        const { data } = await axios.post(`/card/solicitation`, { employee: user });
        return data ? data : {};
    } catch (ex) {
        let error = handlerError(ex);
        return { success: false, ...error };
    }
};

export const createOrderList = async (userIdList) => {
    try {
        const { data } = await axios.post(`/card/solicitations`, { employees: userIdList });
        return data ? data : {};
    } catch (ex) {
        let error = handlerError(ex);
        return { success: false, ...error };
    }
};

export const createCompanyCard = async (company, body) => {
    try {
        const { data } = await axios.post(`/company/${company}/card`, body);
        return data ? data.id : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};


export const loadHistoryCards = async (user, type) => {
    try {
        const { data } = await axios.get(`card/${user}/history?type=${type}`);
        return data.history ? data.history : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const loadAllHistoryCards = async (company) => {
    try {
        const { data } = await axios.get(`card/history`, { params: { company: company } });
        return data.history ? data.history : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const getAllCardSolicitationByCompany = async (company) => {
    try {
        let param = {}
        if (company) {
            param = { params: { company: company } }
        }
        const { data } = await axios.get(`/card/solicitation`, param);
        return data ? data.data : []
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const blockCard = async (userId, card, status="blocked") => {
    try {
        await axios.post(`/card/status/${userId}`, { status: status, card: card.idCard });
        notification.success({
            message: "Cartão bloqueado com sucesso!"
        })
    } catch (ex) {
        handlerError(ex);
        return (null);
    }
}

export const cancelCard = async (card) => {
    try {
        await axios.put(`/card/solicitation/${card}/cancel`, {});
        notification.success({
            message: "Cartão cancelado com sucesso!"
        })
    } catch (ex) {
        handlerError(ex);
        return (null);
    }
}

export const redeliveryCard = async (data) => {
    try {
        await axios.post(`/card/resend`, { ...data });
        notification.success({
            message: "Pedido de reentrega feito com sucesso!"
        })
    } catch (ex) {
        handlerError(ex);
        return (null);
    }
}

export const unblockCard = async (id) => {
    try {
        await axios.post(`/card/${id}/status`, { status: "active" });
        notification.success({
            message: "Cartão desbloqueado com sucesso!"
        })
    } catch (ex) {
        handlerError(ex);
        return (null);
    }
}

export const loadAllSolicitationsCard = async () => {
    try {
        const { data } = await axios.get(`/card/solicitation/user`);
        return data.data ? data.data : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
}

export const updateSolicitationsCard = async (id, status) => {
    try {
        await axios.put(`/card/solicitation/user/${id}`, { status: status });
        notification.success({
            message: status == 's' ? 'Envio criado com sucesso!' : 'Cartão entregue com sucesso!'
        })
    } catch (ex) {
        handlerError(ex);
        return (null);
    }
}

export const issueVirtualCard = async (issuanceList) => {
    try {
        const response = await axios.post(`/card/virtual`, issuanceList);
        return response.data;
    } catch (error) {
        console.log(error);
        return null;
    }

}

export const issueCorporateVirtualCard = async (userId, data) => {
    try {
        const response = await axios.post(`/corporate/card/${userId}`, data);
        return response.data;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getCorporateCardEmployees = async () => {
    try {
        const { data } = await axios.get('/corporate/card/employees');
        return data.employees || [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};


export const retrieveCorporateCardEmployee = async (userId) => {
    try {
        const { data } = await axios.get(`/corporate/card/employee/${userId}`);
        return data.employee || null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getCorporateAccount = async (userId) => {
    try {
        const { data } = await axios.get(`/corporate/card/account?user=${userId}`);
        return data.employees?.[0] || null;
    } catch (ex) {
        return null;
    }
};

export const blockCorporateCard = async (userId, action) => {
    try {
        await axios.put(`/corporate/card/${userId}/status`, { action });
    } catch (ex) {
        handlerError(ex);
    }
};

export const removeCorporateAccount = async (userId) => {
    try {
        await axios.delete(`/corporate/card/${userId}/account`);
    } catch (ex) {
        handlerError(ex);
        throw ex;
    }
};
